import * as O from "fp-ts/Option"
import * as F from "fp-ts/function"
import * as ROA from "fp-ts/ReadonlyArray"
import * as P from "fp-ts/Predicate"
import { FareCode } from "@silversea-ssc/web-fares-fp"
import { FareContent } from "../../../_common/sanity/sanity-types"
import { ECommerceContext } from "../machines/ecommerce-machine/e-commerce-machine-context"
import { FareCard, FareCardIndex, FareCardKey } from "./fare-card"

type Context = Pick<ECommerceContext, "fareCards">

export function fareCardByKey(ctx: Context, key: FareCardKey): FareCard
export function fareCardByKey(ctx: Context, key: FareCardKey | undefined): FareCard | undefined
export function fareCardByKey(ctx: Context, key?: FareCardKey | undefined): FareCard | undefined {
    return F.pipe(maybeFareCardByKey(ctx, key), O.toUndefined)
}

export const maybeFareCardByKey = (ctx: Context, key: FareCardKey | undefined): O.Option<FareCard> =>
    F.pipe(
        ctx.fareCards,
        ROA.findFirst((x) => x.key === key),
    )

export const maybeContentByFareCode = (content: FareContent[] | undefined, fareCode: FareCode): O.Option<FareContent> =>
    O.fromNullable(content?.find((c) => c.fareCodes.includes(fareCode)))

export const hasNoAvailability = (fareCards: readonly FareCard[]): boolean => {
    if (fareCards.length === 0) return false

    const haveAvailablePrices = fareCards.some(F.pipe(FareCard.hasStatus("good"), P.or(FareCard.hasStatus("unknown"))))
    if (haveAvailablePrices) return false

    return fareCards.some(FareCard.hasStatus("noAvailablePrice"))
}

export const maybeFareCardByIndex = (ctx: Context, index: FareCardIndex | undefined): O.Option<FareCard> =>
    F.pipe(
        ctx.fareCards,
        ROA.findFirst((x) => x.index === index),
    )
